<template>
  <div class="ai-friend-role-tag">
    <ConfigTable ref="ct" :searchConfig="searchConfig" :tableColumns="tableColumns" :tableData="list" :total="total"
      @change="loadData" @edit="edit" @add="add" @delete="deleteRow"></ConfigTable>
    <EditRoleTag ref="editDialog" @sure="callEdit"></EditRoleTag>
  </div>
</template>

<script>
import { Switch, Image } from 'element-ui';
import baseConfig from "@/utils/serverUrlConfig";
import { changeDate } from '../../../utils/filter';
import ConfigTable from '@/components/config-table';
import aiFriendApi from '../../../api/aiFriendManage';
import EditRoleTag from './components/EditRoleTag.vue';
import { toggleOptions } from '../../config';

const searchConfig = [
  { type: 'input', placeholder: '输入标签名称', key: 'name' },
  { type: 'select', placeholder: '是否热门标签', key: 'isHot', options: toggleOptions },
  { type: 'select', placeholder: '是否开启标签', key: 'status', options: toggleOptions },
  { type: 'button', icon: 'search', placeholder: '搜索', key: 'search' },
  { type: 'button', icon: 'plus', placeholder: '新增', key: 'add' },
]

const singleImgProps = (val) => {
  const src = baseConfig.imgUrl + val;
  return { src, 'preview-src-list': [src] }
}

const tableColumns = [
  { name: 'ID', key: 'id', width: 220, fixed: 'fixed' },
  { name: '名称', key: 'name' },
  {
    name: '图标', key: 'icon', component: Image, props: singleImgProps
  },
  {
    name: '是否热门', key: 'isHot', component: Switch, props(value) {
      return { value, disabled: true }
    }
  },
  { name: '详细描述', key: 'description' },
  // { name: '类型', key: 'type' },
  { name: '排序', key: 'sort' },
  {
    name: '状态', key: 'status', component: Switch, props(value) {
      return { value, disabled: true }
    }
  },
  { name: '权重', key: 'weight' },
  {
    name: '创建时间', key: 'createdAt', valueHandler: changeDate
  },
  {
    name: '更新时间', key: 'updatedAt', valueHandler: changeDate
  },
  { name: '操作', fixed: 'right', actions: ['edit', 'delete'] },
];

export default {
  name: 'AiFriendRoleTagManage',
  components: { ConfigTable, EditRoleTag },
  data() {
    return {
      searchConfig,
      tableColumns,
      total: 0,
      list: [],
    };
  },
  watch: {

  },
  mounted() {

  },
  methods: {
    async loadData(params) {
      try {
        const r = await aiFriendApi.getAiRoleTagList(params)
        const data = r.data
        this.total = data.total
        this.list = data.list
      } catch (error) {
        console.error('搜索ai角色标签失败：', error);
      }
    },
    add() {
      this.$refs.editDialog.open()
    },
    edit(row) {
      this.$refs.editDialog.open(row)
    },
    async deleteRow(row) {
      try {
        await this.$confirm("您确定要删除该条数据吗？", "操作提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        await aiFriendApi.delAiRoleTag({ id: row.id })
        this.$message.success('已删除')
        this.$refs.ct.search()
      } catch (error) {
        console.log(error);
      }
    },
    async callEdit(r) {
      try {
        console.log(r);
        await (r.isEdit ? aiFriendApi.updateAiRoleTag(r.data) : aiFriendApi.createAiRoleTag(r.data))
        this.$message.success(r.isEdit ? '更新成功' : '新增成功')
        this.$refs.editDialog.close()
        setTimeout(() => {
          this.$refs.ct.search()
        }, 200);
      } catch (error) {
        console.error('call edit error:', error);
      }
    },
  }
};
</script>

<style lang="scss" scoped>
.ai-friend-role-tag {

  /deep/ .el-button {
    padding: 9px 15px;
  }

  /deep/ .el-image {
    width: 100px;
    height: 100px;

    img {
      object-fit: contain;
    }
  }
}
</style>